module.exports = __webpack_public_path__ + "static/media/city-jemjar.686b6f62.png";